import React from "react";
import {
  List,
  Datagrid,
  TextField,
  RichTextField,
  ImageField,
  EditButton,
  SelectField,
} from "react-admin";
import { panels } from "./constants";
const SponsorPanel = () => <RichTextField source="bio" />;

export default (props) => (
  <List {...props} perPage={50} pagination={false}>
    <Datagrid rowClick="edit" expand={<SponsorPanel />}>
      <ImageField source="image" />
      <TextField source="name" />
      <TextField source="type" />
      <SelectField source="panel" choices={panels} />
      <TextField source="priority" />
      <EditButton />
    </Datagrid>
  </List>
);
